package org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class Furniture(
    @SerialName("caption")
    val caption: String?=null,
    @SerialName("componentColor")
    val componentColor: String?=null,
    @SerialName("floorId")
    val floorId: String?=null,
    @SerialName("height")
    val height: Int?=null,
    @SerialName("id")
    val id: String?=null,
    @SerialName("mod_ver")
    val modVer: Int?=null,
    @SerialName("objectKind")
    val objectKind: String?=null,
    @SerialName("objectType")
    val objectType: String?=null,
    @SerialName("positionLeft")
    val positionLeft: Int?=null,
    @SerialName("positionTop")
    val positionTop: Int?=null,
    @SerialName("projectId")
    val projectId: String?=null,
    @SerialName("roomId")
    val roomId: String?=null,
    @SerialName("rotationDeg")
    val rotationDeg: Int?=null,
    @SerialName("shape")
    val shape: String?=null,
    @SerialName("__typename")
    val typename: String?=null,
    @SerialName("width")
    val width: Int?=null
)